import { render, staticRenderFns } from "./StatisticsGroup.vue?vue&type=template&id=4efd1e79&scoped=true&"
import script from "./StatisticsGroup.vue?vue&type=script&lang=js&"
export * from "./StatisticsGroup.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsGroup.vue?vue&type=style&index=0&id=4efd1e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd1e79",
  null
  
)

export default component.exports